module.exports = __webpack_public_path__ + "static/media/Paramount_Plus.3cf63993.png";